import React from 'react'
import CompareTemplate from 'src/components/template/compare'
import { cableData } from 'src/components/template/compare/components/data/cableData'

export default (props) => <CompareTemplate location={props.location} data={cableData} />
